import React, { createContext, useContext } from 'react'
import defaultSprite from '../../icons/sprite.svg'

const SpriteUrlContext = createContext<string | null>(null)

export function SpriteUrlProvider({ url, children }: { url?: string | null; children: React.ReactNode }) {
  return <SpriteUrlContext.Provider value={url ?? null}>{children}</SpriteUrlContext.Provider>
}

// Returns the URL of the icon sprite. Defaults to the bundler-resolved import, which is
// correct on Vite-rendered pages. Webpack-mounted components (react_component) instead bake
// an undigested `/assets/images/sprite.svg` URL that propshaft can't serve in production, so
// those mounts pass the fingerprinted `asset_path` in via SpriteUrlProvider.
export function useSpriteUrl(): string {
  return useContext(SpriteUrlContext) ?? defaultSprite.toString()
}
